import React, { useState, useEffect } from "react";
import Accordion from "../../components/ui/Accordion";
import AccordionItem from "../../components/ui/AccordionItem";
import "../../styles/Location.css";
import MapImage from "../../assets/india map.jpg";
// Import the map interaction script
import "./mapInteraction.js";  // Adjust the path as needed



// This file contains utility functions for map interaction
// It connects the locations accordion with map markers

// Export these functions to use in the Locations component
export const setupMapInteractions = () => {
  // Only run this after the DOM is fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMapInteractions);
  } else {
    initMapInteractions();
  }
};

// Function to initialize all map interactions
function initMapInteractions() {
  // Map for storing references to accordion headers
  const locationButtons = {};
  
  // Find all location titles and store them
  document.querySelectorAll('.loc-title').forEach(el => {
    const location = el.getAttribute('data-location');
    if (location) {
      locationButtons[location] = el.closest('.accordion-title');
    }
  });
  
  // Add click handlers to all map markers
  document.querySelectorAll('.map-marker').forEach(marker => {
    const locationClass = Array.from(marker.classList)
      .find(cls => cls !== 'map-marker' && cls !== 'active');
    
    if (locationClass) {
      marker.addEventListener('click', () => {
        handleMarkerClick(locationClass);
      });
    }
  });
  
  // Add click handlers to all accordion titles
  document.querySelectorAll('.loc-title').forEach(el => {
    const location = el.getAttribute('data-location');
    const accordionTitle = el.closest('.accordion-title');
    
    if (location && accordionTitle) {
      accordionTitle.addEventListener('click', () => {
        // Update all markers
        document.querySelectorAll('.map-marker').forEach(marker => {
          marker.classList.remove('active');
        });
        
        // Activate the correct marker
        const marker = document.querySelector(`.map-marker.${location}`);
        if (marker) {
          marker.classList.add('active');
          
          // Center view on the marker with animation
          centerMapOnMarker(marker);
        }
        
        // Update button highlighting
        document.querySelectorAll('.accordion-title').forEach(el => {
          el.setAttribute('data-active', 'false');
        });
        accordionTitle.setAttribute('data-active', 'true');
      });
    }
  });
}

// Function to handle map marker clicks
function handleMarkerClick(location) {
  // Find the corresponding accordion button
  const button = document.querySelector(`.loc-title[data-location="${location}"]`)?.closest('.accordion-title');
  
  if (button) {
    // Scroll to the button
    button.scrollIntoView({ behavior: 'smooth', block: 'center' });
    
    // Simulate a click on the button after a small delay
    setTimeout(() => {
      button.click();
    }, 300);
    
    // Highlight the button
    document.querySelectorAll('.accordion-title').forEach(el => {
      el.setAttribute('data-active', 'false');
    });
    button.setAttribute('data-active', 'true');
  }
}

// Function to center the map view on a marker with animation
function centerMapOnMarker(marker) {
  if (!marker) return;
  
  // Make the marker more prominent with animation
  marker.style.transition = 'transform 0.3s ease';
  marker.style.transform = 'translate(-50%, -50%) scale(1.8)';
  marker.style.zIndex = '100';
  
  // Reset the marker style after animation
  setTimeout(() => {
    marker.style.transform = 'translate(-50%, -50%) scale(1.3)';
  }, 1000);
}

// Export a function to manually highlight a specific location
// You can call this from the Locations component
export const highlightLocation = (locationId) => {
  if (!locationId) return;

  // Remove active & blink from all markers
  document.querySelectorAll('.map-marker').forEach(marker => {
    marker.classList.remove('active', 'blink');
  });

  const marker = document.querySelector(`.map-marker.${locationId}`);
  if (marker) {
    marker.classList.add('active');

    // Force reflow to restart animation
    marker.classList.remove('blink');
    void marker.offsetWidth;
    marker.classList.add('blink');

    // Center + animate
    centerMapOnMarker(marker);
  }

  // Highlight accordion
  document.querySelectorAll('.accordion-title').forEach(el => {
    el.setAttribute('data-active', 'false');
  });

  const button = document
    .querySelector(`.loc-title[data-location="${locationId}"]`)
    ?.closest('.accordion-title');

  if (button) {
    button.setAttribute('data-active', 'true');
  }
};



